export enum GameLevelCategory {
  QUIZ = 'quiz',
  CHAT_LEVEL = 'chat_level',
  SEARCH_IMAGE_LEVEL = 'search_image_level'
}
